import { useState } from "react";
import axios from 'axios'
import { useTranslation } from "react-i18next";

function ContactUsPage() {

    const [formvalue, setformvalue] = useState({
        username: "",
        email: "",
        phone: "",
        subject: "",
        message: ""
    })


    const sendemail = async () => {

        //   const detalhemensagem = "Mensagem de :" + formvalue.username + ""
        //     + "Email: " + formvalue.email
        //     + "Fone: " + formvalue.phone + "Assunto" + formvalue.subject + ""
        //     + "mensagem:" + formvalue.message

        //     const brevo = require('@getbrevo/brevo');
        //     let defaultClient = brevo.ApiClient.instance;

        //     let apiKey = defaultClient.authentications['api-key'];
        //     apiKey.apiKey = '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';

        //     let apiInstance = new brevo.TransactionalEmailsApi();
        //     let sendSmtpEmail = new brevo.SendSmtpEmail();

        //     sendSmtpEmail.subject = "Email do site aiprompts";
        //     sendSmtpEmail.htmlContent = detalhemensagem;
        //     sendSmtpEmail.sender = { "name": "John", "email": "microedonline@gmail.com" };
        //     sendSmtpEmail.to = [
        //       { "email": "microedonline@gmail.com", "name": "sample-name" }
        //     ];
        //    // sendSmtpEmail.replyTo = { "email": "example@brevo.com", "name": "sample-name" };
        //    // sendSmtpEmail.headers = { "Some-Custom-Name": "unique-id-1234" };
        //    // sendSmtpEmail.params = { "parameter": "My param value", "subject": "common subject" };


        //     apiInstance.sendTransacEmail(sendSmtpEmail).then(function (data) {
        //       console.log('API called successfully. Returned data: ' + JSON.stringify(data));
        //     }, function (error) {
        //       console.error(error);
        //     });
    }

    const setvalues = (e, type) => {

        if (type == "username") {
            setformvalue({
                username: e.target.value,
                email: formvalue.email,
                phone: formvalue.phone,
                subject: formvalue.subject,
                message: formvalue.message
            })
        }

        if (type == "email") {
            setformvalue({
                username: formvalue.username,
                email: e.target.value,
                phone: formvalue.phone,
                subject: formvalue.subject,
                message: formvalue.message
            })
        }

        if (type == "subject") {
            setformvalue({
                username: formvalue.username,
                email: formvalue.email,
                phone: formvalue.phone,
                subject: e.target.value,
                message: formvalue.message
            })
        }

        if (type == "phone") {
            setformvalue({
                username: formvalue.username,
                email: formvalue.email,
                phone: e.target.value,
                subject: formvalue.subject,
                message: formvalue.message
            })
        }


        if (type == "message") {
            setformvalue({
                username: formvalue.username,
                email: formvalue.email,
                phone: formvalue.phone,
                subject: formvalue.subject,
                message: e.target.value
            })
        }


    }


    const handleSubmit = (event) => {
        console.log('A name was submitted: ' + event.target.value)
        event.preventDefault();
    }

    const { t, i18n } = useTranslation()

    return (
        <>
            <div className="section-full twm-contact-one">
                <div className="section-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-12">
                                <div className="contact-form-outer">
                                    {/* title="" START*/}
                                    <h2 className="wt-title">{t("contact.sendmessage")}</h2>
                                    <p>{t("contact.feelfree")}</p>
                                    {/* title="" END*/}
                                    {/* <form className="cons-contact-form" method="post">
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group mb-3">
                                                    <input onChange={(e) => setvalues(e, "username")} name="username" type="text" required className="form-control" placeholder={t("contact.pname")} />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group mb-3">
                                                    <input name="email" onChange={(e) => setvalues(e, "email")} type="text" className="form-control" required placeholder="Email" />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group mb-3">
                                                    <input name="phone" onChange={(e) => setvalues(e, "phone")} type="text" className="form-control" required placeholder={t("contact.pphone")} />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group mb-3">
                                                    <input name="subject" onChange={(e) => setvalues(e, "subject")} type="text" className="form-control" required placeholder={t("contact.psubject")} />
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="form-group mb-3">
                                                    <textarea name="message" onChange={(e) => setvalues(e, "message")} className="form-control" rows={3} placeholder={t("contact.pmessage")} defaultValue={""} />
                                                </div>
                                            </div>

                                        </div>
                                    </form> */}

                                    <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSeGx3xRwY2UPgvafauy89LEBZVj3rRYzDSQE895oAi9q17jvA/viewform?embedded=true" width="640" height="687" frameborder="0" marginheight="0" marginwidth="0">Carregando…</iframe>

                                    {/* <div className="col-md-12">
                                        <button onClick={(e) => sendemail()} className="site-button">{t("contact.submitnow")}</button>
                                    </div> */}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default ContactUsPage;